import React, { useEffect, useState } from 'react'
import { Card } from 'reactstrap'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import erorSound from '../../assets/audio/alert-error.wav'
import Breadcrumb from '../../components/common/breadcrumb'
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani'
import useFormatMessage from '../../utils/useFormatMessage'
const AracSorgulama = () => {

    const { t } = useFormatMessage()
    const [data, setData] = useState(null)
    // const [mutibleData, setMutibleData] = useState(null)
    useEffect(() => {
        if (document.querySelector(".swal2-container") === null) {
            if (data && data.error) {

                if (navigator.vibrate) {
                    // 500ms titreşim sağlıyoruz
                    navigator.vibrate(500);
                }
                const errorSound = document.getElementById("errorSound");
                errorSound.play();


                if (data.error.includes("multiple vehicles found with chassis number")) {
                    // setMutibleData(
                    //     data.error.split(":")[1]?.split(",")
                    // )
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: t(data.error?.split(":")[0]) + " " + t(data.error?.split(":")[1]),
                    })
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: t(data.error),
                    })
                }

            }
            // else {
            //     setData(null)
            // }
        }
        // eslint-disable-next-line
    }, [data])
    return (
        <>
            <Breadcrumb current={t("Araç Sorgulama")} />
            <Card className='p-2'>
                <SorgulamaEkrani apiEndpoint="/vehicle/getByVehicleID" body={"sase"} setData={setData} minCharacter={7}

                />
                {/* {mutibleData && <SelectBox dataSource={mutibleData} />} */}
                <audio id="errorSound" src={erorSound} preload="auto"></audio>
                <hr />
                <div style={{
                    textAlign: "center",
                    width: "100%",
                }}>

                    {
                        data !== null && <>
                            <p>
                                {data["assigned_address"] ? (
                                    <span style={{ fontSize: "22px" }} > {data["assigned_address"]["warehouse_name"]}</span>
                                ) : null}
                                {data["assigned_address"] ? (
                                    <span style={{ fontSize: "22px" }} > {data["assigned_address"]["zone_name"]}</span>
                                ) : null}
                                {data["assigned_address"] ? (
                                    <span style={{ fontSize: "22px" }} > <b>{data["assigned_address"]["address_code"]}</b></span>
                                ) : null}

                            </p>

                            <hr />

                            {data?.is_active === false ? (
                                <div className='alert alert-dark' role='alert'>
                                    {/* Bu araç stokta değil. */}
                                    ⚠️  {t("Bu araç stokta değildir.")}
                                </div>
                            ) : null}

                            {data?.brand ? (
                                <p style={{ fontSize: "22px" }} > {data.brand}</p >
                            ) : null}

                            {data?.Data?.["commercial denomination code"] ? (
                                <p style={{ fontSize: "22px" }} > {data.Data["commercial denomination code"]}</p >
                            ) : null}
                            {data["model"] ? (
                                <p style={{ fontSize: "22px" }} > {data["model"]}</p >
                            ) : null}
                            {data?.Data?.["commercial denomination name"] ? (
                                <p style={{ fontSize: "22px" }} > {data.Data["commercial denomination name"]}</p >
                            ) : null}

                            {
                                data?.["color"] ? (
                                    <p style={{ fontSize: "22px" }} > {data["color"]}</ p>
                                ) : null}


                            {
                                data?.Data?.["warning"] ? (
                                    <p>
                                        {(data.Data["warning"]["info"] !== null && data.Data["warning"]["info"] !== "") && (
                                            <span
                                                style={{
                                                    fontSize: "22px",
                                                    padding: "15px 20px",
                                                    background: "#ffab3361",
                                                    borderRadius: "15px",
                                                    fontWeight: "700",
                                                }}
                                            >
                                                <span role="img" aria-label="warning">
                                                    ⚠️
                                                </span>{" "}
                                                {data.Data["warning"]["info"]}
                                            </span>
                                        )}
                                    </p>

                                ) : null}

                            <div>

                            </div>

                        </>
                    }
                </div >

            </Card >
        </>
    )
}

export default AracSorgulama